import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface Permission {
  _id: string;
  permission_key: string;
  permission_name: string;
  description?: string;
  meta_data?: { module?: string; [k: string]: any };
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface PermissionListParams {
  skip?: number;
  limit?: number;
  permission_name?: string;
  permission_key?: string;
}

export interface PermissionListResponse {
  success: boolean;
  code: number;
  description?: string;
  data: {
    permissions: Permission[];
    total_count: number;
  };
}

export interface PermissionDropdownItem {
  _id: string;
  permission_key: string;
  permission_name: string;
}

export interface RolePermissionsResponse {
  success: boolean;
  code: number;
  description?: string;
  data: {
    role_key: string;
    role_name: string;
    permissions: string[];
  };
}

export interface AssignPermissionsBody {
  role_key: string;
  permissions: string[];
}

class PermissionsService {
  /** Paginated list (used by the picker page — set limit high to fetch all 47 in one call). */
  async listPermissions(params: PermissionListParams = {}): Promise<PermissionListResponse> {
    const body = { skip: 0, limit: 200, ...params };
    const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS.LIST, body);
    return response.data;
  }

  /** Minimal {_id, key, name} for dropdowns. */
  async getPermissionsDropdown(): Promise<PermissionDropdownItem[]> {
    const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS.DROPDOWN);
    return response.data?.data || [];
  }

  /** Get the permission keys currently assigned to a role. */
  async getRolePermissions(role_key: string): Promise<RolePermissionsResponse['data']> {
    const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS.ROLE_GET(role_key));
    return response.data?.data;
  }

  /** Replace the entire permissions array on a role (upsert). */
  async assignPermissionsToRole(payload: AssignPermissionsBody) {
    const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS.ROLE_ASSIGN, payload);
    return response.data?.data;
  }
}

export const permissionsService = new PermissionsService();
export default permissionsService;
